/**
 * @function getTactileAction
 * @description Returns the correct tactile action for the current device.
 * @returns string
 */
export const tactileAction = window.matchMedia('(any-hover: none)').matches
  ? 'Tap'
  : 'Click';
